import React from 'react';
import { compose } from 'redux';
import { PapiDeviation } from '@wix/da-papi-types';
import ContainerSize from '../../../ContainerSize';
import SelectableDeviationWrapper from '../SelectableDeviationWrapper';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import { getDeviationEntityId } from '../../../redux/normalizr/schemas/deviation';
import GallectionDeviationControlButtons from '../GallectionDeviationControlButtons';
import CustomSetDeviationControlButtons from '../CustomSetDeviationControlButtons';
import TierDeviationControlButtons from '../TierDeviationControlButtons';
import withSelectedDeviations, {
  WithSelectedDeviationsProps,
} from '../../_hocs/withSelectedDeviations';
import withCurrentMediaSource, {
  WithCurrentMediaSourceProps,
} from '../../_hocs/withCurrentMediaSource';
import { MediaSourceType } from '../../types';
import IndicatorForDeviationThumb from '../IndicatorForDeviationThumb';
// eslint-disable-next-line @wix/da/scss-same-filename-as-module
import s from './ManageableDeviation.scss';

export interface Props {
  index: number;
  deviation: PapiDeviation;
}

const enhance = compose(withSelectedDeviations, withCurrentMediaSource);

class ManageableDeviation extends React.Component<
  Props & WithSelectedDeviationsProps & WithCurrentMediaSourceProps
> {
  render() {
    const { deviation, selectedDeviations, currentMediaSource } = this.props;

    let ControlButtons;
    switch (currentMediaSource) {
      case MediaSourceType.CUSTOM_SET:
        ControlButtons = CustomSetDeviationControlButtons;
        break;
      case MediaSourceType.TIER_DEVIATIONS:
      case MediaSourceType.TIER_POSTS:
        ControlButtons = TierDeviationControlButtons;
        break;
      case MediaSourceType.PRIVATE_COLLECTION:
      case MediaSourceType.COLLECTION:
      case MediaSourceType.GALLERY:
      case MediaSourceType.STASH:
        ControlButtons = GallectionDeviationControlButtons;
        break;
      default:
        return null;
    }

    const isAnySelected = !!selectedDeviations.length;

    return (
      <ContainerSize className={s['measured-container']}>
        {({ width, height }) => (
          <SelectableDeviationWrapper
            key={getDeviationEntityId(deviation)}
            deviation={deviation}
            className={s['deviation-wrapper']}
          >
            <DeviationDumbView
              deviation={deviation}
              width={width}
              height={height}
            />
            <IndicatorForDeviationThumb
              deviation={deviation}
              className={s['indicator']}
            />
            {!isAnySelected && (
              <div
                className={s['control-buttons']}
                onClick={this.onControlButtonsWrapperClick}
              >
                <ControlButtons deviation={deviation} />
              </div>
            )}
          </SelectableDeviationWrapper>
        )}
      </ContainerSize>
    );
  }

  onControlButtonsWrapperClick(event) {
    event.stopPropagation();
  }
}

export default enhance(
  ManageableDeviation
) as any as React.ComponentClass<Props>;
